import { createContext, useContext, type ReactNode } from "react";
import { useDashboardData } from "../hooks/useDashboardData";
import type { DashboardSnapshot } from "../types/dashboard";

type ChargerLogRequestResult = {
  charger_id: string;
  source: "ocpp" | "ws";
  filePath?: string;
  lines: string[];
  truncated?: boolean;
  file_size?: number;
  scanned_bytes?: number;
  limit?: number;
  can_load_more?: boolean;
};

type DashboardContextValue = {
  snapshot: DashboardSnapshot;
  sendPresence: (topic: string, path: string) => void;
  requestChargerLog: (
    chargerId: string,
    source: "ocpp" | "ws",
    limit: number,
  ) => Promise<ChargerLogRequestResult>;
  wsReady: boolean;
};

const DashboardContext = createContext<DashboardContextValue | null>(null);

export function DashboardProvider({ children }: { children: ReactNode }) {
  const value = useDashboardData();
  return <DashboardContext.Provider value={value}>{children}</DashboardContext.Provider>;
}

export function useDashboard() {
  const ctx = useContext(DashboardContext);
  if (!ctx) throw new Error("useDashboard must be used within DashboardProvider");
  return ctx.snapshot;
}

export function useDashboardWs() {
  const ctx = useContext(DashboardContext);
  if (!ctx) throw new Error("useDashboardWs must be used within DashboardProvider");
  return ctx;
}
